import BaseComponent from '@/js/core/BaseComponent'
import DOMRenderer from '@/js/hooks/renderer'
import Events from '@/js/core/EventDispatcher'
import gsap from 'gsap'
import $ from 'jquery'

export default class Filterable extends BaseComponent {
  static OVERLAY_OPEN = 'overlay--open'

  static root = '[data-fetch-ws]'

  state = {
    ...this.state,
    fetchPage: 1,
    filters: {},
  }

  selectors = {
    'fetch': '[data-fetch-submit]',
    'btns[]': '[data-filter-button]',
    'reset[]': '[data-filter-reset]',
    'panels[]': '[data-filter-panel]',
    'submit[]': '[data-filter-submit]',
    'actions': '[data-fetch-actions]',
    'message': '[data-fetch-message]',
    'overlay': '[data-filter-overlay]',
    'resetAll': '[data-filter-reset-all]',
    'container': '[data-fetch-container]',
    'checkbox[]': '[data-filter-checkbox]',
    'background[]': '[data-filter-background]'
  }

  listeners = {
    'click @btns': ({ currentTarget }) => {
      const key = $(currentTarget).data('filter-key')
      this.$.panel = this.$.panels.filter(`[data-filter-key="${key}"]`)
      this.$.panel.show().siblings().hide()
      this.openPanel()
    },
    
    'change @checkbox': ({ currentTarget }) => {
      const $checkbox = $(currentTarget)
      const $panel = $checkbox.parents('[data-filter-panel]')
      const active = $checkbox.prop('checked')
      const value = $checkbox.data('filter-value')
      const key = $panel.data('filter-key')

      if (!active)
        this.removeFilter(value, key)
      else this.addFilter(value, key)
    },

    'click @submit': async () => {
      this.setState(() => ({ fetchPage: 1 }))
      this.$.panel.addClass('loading')
      
      await this.refresh(true)
      
      this.$.panel.removeClass('loading')
      this.closePanel()
    },

    'click @reset': () => {
      this.$.panel.find('[data-filter-checkbox]').prop('checked', false)
      this.clearFilter(this.$.panel.data('filter-key'))
    },

    'click @background': () => {
      this.closePanel()
    },

    'click @fetch': async ({ currentTarget }) => {
      const $button = $(currentTarget)
      $button.addClass('loading')

      this.setState(({ fetchPage }) => ({
        fetchPage: fetchPage + 1 
      }))
      
      await this.refresh()
      
      $button.removeClass('loading')
      // this.setState(({ fetchPage }) => ({
      //   fetchPage: fetchPage + 1 
      // }))
    },

    'click @resetAll': async ({ currentTarget }) => {
      const $button = $(currentTarget)

      
      this.clearAllFilters()
      this.setState(() => ({ filters: {}, fetchPage: 1 }))
      this.$.checkbox.prop('checked', false)
      $button.addClass('loading')
      
      await this.refresh(true)
      
      $button.removeClass('loading')
    }
  }

  query () {
    return this.state.fetchTemplate === 'collection'
      
      ? `parents/${Object.keys(this.state.filters).map(key => 
          this.state.filters[key].join('-'))}` 
           
      : (this.state.fetchTemplate === 'news' && this.state.fetchCategory !== undefined) 
      
      ? `?categories=${this.state.fetchCategory}&page=${this.state.fetchPage}&per_page=${this.state.fetchPerPage}&tax_relation=OR&filter[orderby]=date&order=desc`
      
      : (this.state.fetchTemplate === 'news')
      
      ? `?${Object.keys(this.state.filters).map(key => 
        `categories=${encodeURIComponent(this.state.filters[key].join(','))}`
        ).join('&')}&page=${this.state.fetchPage}&per_page=${this.state.fetchPerPage}&tax_relation=OR&filter[orderby]=date&order=desc`
      
      : `?${Object.keys(this.state.filters).map(key => 
          `${key}=${encodeURIComponent(this.state.filters[key].join(','))}`
        ).join('&')}&page=${this.state.fetchPage}&per_page=${this.state.fetchPerPage}&tax_relation=AND`
  }

  // query () {
  //   return this.state.fetchTemplate === 'collection'
      
  //     ? `parents/${Object.keys(this.state.filters).map(key => 
  //         this.state.filters[key].join('-'))}` 
           
  //     : (this.state.fetchTemplate === 'news') 
      
  //     ? `?${Object.keys(this.state.filters).map(key => 
  //         `categories=${encodeURIComponent(this.state.filters[key].join(','))}`
  //       ).join('&')}&page=${this.state.fetchPage}&per_page=${this.state.fetchPerPage}&tax_relation=OR&filter[orderby]=date&order=desc`
      
  //     : `?${Object.keys(this.state.filters).map(key => 
  //         `${key}=${encodeURIComponent(this.state.filters[key].join(','))}`
  //       ).join('&')}&page=${this.state.fetchPage}&per_page=${this.state.fetchPerPage}&tax_relation=AND`
  // }

  debug () {
    const key = this.$.panels.data('filter-key')
    const json = JSON.stringify(this.state.filters[key]) || '[]'
    this.$.panels.find('[data-filter-debug]').html(`${json}<br>${this.query()}`)
  }

  doQueryParamsTranslate(queryStringParams) {
    return  queryStringParams.map(elem => document.querySelector(`input[data-filter-value="${elem}"]`) ? document.querySelector(`input[data-filter-value="${elem}"]`).getAttribute('data-filter-id') : null).filter(item => item !== null)
  }

  doQueryParams(queryString_) {
    let outUrl = '?';
    queryString_ = this.parseQuery(queryString_.split('?')[1].split('&page=')[0])
    for (const [key, value] of Object.entries(queryString_)) {
      //console.log(`${key}: ${value} -> ${this.doQueryParamsTranslate(value.split(','))}`);
      if (this.doQueryParamsTranslate(value.split(',')).join(',') != false) {
        outUrl = outUrl + `${key.replace('_cta_','')}=${this.doQueryParamsTranslate(value.split(',')).join(',')}&`
      }
    }
    window.history.pushState({page: "Mipa"}, "Mipa", outUrl);

  }

  doCollectionsQueryParamsTranslate(queryStringParams) {
    queryStringParams = queryStringParams.filter(elem => elem !== null && document.querySelector(`input[data-filter-value="${elem}"]`) !== null && document.querySelector(`input[data-filter-value="${elem}"]`).hasAttribute('data-filter-id'));
    queryStringParams = queryStringParams.map(elem => document.querySelector(`input[data-filter-value="${elem}"]`).getAttribute('data-filter-id')).filter(elem => elem !== null);
    return  queryStringParams.length > 0 ? queryStringParams : [];
  }


  doCollectionsQueryParams(queryString_) {
    let outUrl = '?';
    queryString_ = this.parseQuery(queryString_.split('/parents/')[1]);
    for (const [key, value] of Object.entries(queryString_)) {
      let theValue = value.split('/').length > 1 ? value.split('/')[1] : false;
      let theValueArr = key.split('-');  
      if (this.doCollectionsQueryParamsTranslate(theValueArr).length > 0 != false) {
        let currKey = document.querySelector(`[data-filter-panel]`).getAttribute('data-filter-key');
        outUrl = outUrl + `${currKey.replace('_cta_','')}=${this.doCollectionsQueryParamsTranslate(theValueArr).join(',')}&`
      }
    }
    window.history.pushState({page: "Mipa"}, "Mipa", outUrl);

  }

  parseQuery(queryString) {
    let query = {};
    let pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (let i = 0; i < pairs.length; i++) {
        let pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
  }

  update () {
    for (const key in this.state.filters) {
      const filter = this.state.filters[key]
      const pill = this.$.btns.filter(`[data-filter-key=${key}]`)
      pill[filter.length ? 'addClass' : 'removeClass']('active')
      pill.find('[data-filter-badge]').html(filter.length)
    }
  }

  refresh (empty = false, cquery = false) {
    return new Promise(async resolve => {
      const { fetchWs, fetchTemplate } = this.state
      let service = `${fetchWs}${this.query()}`
      if (cquery) {
        service = `${fetchWs}${cquery}`
      }
      if (this.state.fetchTemplate === 'product') {
        this.doQueryParams(service)
        console.log({service})
      }
      if (this.state.fetchTemplate === 'collection') {
        this.doCollectionsQueryParams(service)
        console.log({service})
      }

      const { $nodes, pages } = await DOMRenderer[fetchTemplate].render(service)

      console.log($nodes)

      this.$.actions && this.$.actions.show()
      this.$.message && this.$.message.hide()

      if (parseInt(pages) === 0 ||
          parseInt(pages) === this.state.fetchPage) 
        this.$.actions && this.$.actions.hide()

      if (empty) this.$.container.empty()
      if ($nodes.length) {
        this.$.container.append($nodes)
            .find('[data-image-ratio]')
            .not('[data-setup]')
            .ratio()
        gsap.fromTo($nodes
            , { autoAlpha: 0, y: 40 }
            , { autoAlpha: 1, y: 0
              , duration: .6, ease: 'power2.out', stagger: .1, clearProps: 'all' })
      } else this.$.message && this.$.message.show()

      Events.emit('layout:update')
      
      resolve()
    })
  }

  addFilter (value, key) {
    if (!this.state.filters[key])
      this.state.filters[key] = []
    this.state.filters[key].push(value)
    this.update()
    this.debug()
  }

  removeFilter (value, key) {
    if (!this.state.filters[key]) return
    const index = this.state.filters[key].indexOf(value)
    if (index > -1) this.state.filters[key].splice(index, 1)
    this.update()
    if (this.state.filters[key].length === 0) 
      this.deleteFilter(key)
    this.debug()
  }

  clearFilter (key) {
    if (!this.state.filters[key]) return
    const { length } = this.state.filters[key]
    this.state.filters[key].splice(0, length)
    this.update()
    this.deleteFilter(key)
    this.debug()
  }
  
  clearAllFilters () {
    for (const key in this.state.filters) {
      const filter = this.state.filters[key]
      while (filter.length) {
        const value = filter[0]
        this.removeFilter(value, key)
      }
    }
  }

  deleteFilter (key) {
    if (!this.state.filters[key]) return
    delete this.state.filters[key]
  }

  openPanel () {
    this.$.body.addClass(Filterable.OVERLAY_OPEN)
    //gsap.set(this.$els.overlay, { autoAlpha: 1 })
  }

  closePanel () {
    //gsap.set(this.$els.overlay, { autoAlpha: 0 })
    this.$.body.removeClass(Filterable.OVERLAY_OPEN)
  }

  mounted () {
    super.mounted()
    console.log(this.$.el.data())
    this.state = { 
      ...this.state, 
      ...this.$.el.data(),
    }

    if (this.hasAutoload()) {
      // this.setState(() => ({ fetchPage: 1 }))
      // console.log('autoloading:', window.autoload)
      // this.refresh(true, window.autoload)
      const allChecks = document.querySelectorAll('[data-filter-checkbox]')
      for (let i = 0; i < allChecks.length; ++i) {
        const $checkbox = $(allChecks[i])
        const $panel = $checkbox.parents('[data-filter-panel]')
        const active = $checkbox.prop('checked')
        const value = $checkbox.data('filter-value')
        const key = $panel.data('filter-key')

        if (!active)
          this.removeFilter(value, key)
        else this.addFilter(value, key)
      }
    }
  }

  hasAutoload () {
    if (window.autoload) {
      return true
    } 
    return false
  }
}